// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__7bOui","dark":"MainHeader_dark__mSHQ8"};